import { useQuery } from 'react-query'
import { useSnackbar } from 'notistack'
import {
  getGlobalDataUsage,
  GlobalDataUsageParams,
} from 'services/cm-api/get-global-data-usage'

export function useGlobalDataUsage(params: GlobalDataUsageParams = {}) {
  const { enqueueSnackbar } = useSnackbar()

  return useQuery(
    ['getGlobalDataUsage', params],
    () => getGlobalDataUsage(params),
    {
      enabled: Boolean(localStorage.getItem('FB_ACCESS_TOKEN')),
      keepPreviousData: true,
      staleTime: 60_000,
      onError: (err) => {
        enqueueSnackbar('Cannot get global data usage', { variant: 'error' })
        console.error('Failed to fetch global data usage:', err)
      },
    },
  )
}
